import { render } from "./gameList.vue?vue&type=template&id=4d1f21eb"
import script from "./gameList.vue?vue&type=script&lang=js"
export * from "./gameList.vue?vue&type=script&lang=js"

import "./gameList.vue?vue&type=style&index=0&id=4d1f21eb&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__